import { mergeClassNames } from "@bokio/utils/classes";

import type { MouseEventHandler, RefObject } from "react";

import * as styles from "./linkButton.scss";

interface LinkButtonProps {
	children: (string | number) | (string | number)[];
	onClick?: MouseEventHandler;
	testId?: string;
	disabled?: boolean;
	className?: string;
	type?: "submit" | "reset" | "button";
}

/**
 * TODO: move this button to the appropriate folder. Possibly with `Link`
 */
export const LinkButton = ({
	ref,
	children,
	onClick,
	testId,
	disabled,
	className,
	type,
}: LinkButtonProps & { ref?: RefObject<HTMLButtonElement | null> }) => {
	return (
		<button
			ref={ref}
			className={mergeClassNames(styles.btnLink, className)}
			onClick={e => {
				e.preventDefault();
				onClick && onClick(e);
			}}
			disabled={disabled}
			data-testid={testId}
			type={type}
		>
			{children}
		</button>
	);
};
